<mat-form-field #formFieldContainer floatLabel="always" class="avl-current-location-gmap-wrapper"  [ngClass]="disabled ? 'disable-element' : ''">
    <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <div #targetMap [id]="fieldName+'_map'" style="height: 100%;  width: 100%;  overflow: hidden;">

    </div>
    <br>
    <mat-slide-toggle (change)="setShowVehicleList(isShowAvlVehicles)">View Vehicles</mat-slide-toggle>
</mat-form-field>
